<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-wrench'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [totalCost]="totalCost"
  [percentageDifference]="percentageDifference"
  [costDifference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isUptrendPositive]="false"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [hasCost]="true"
  [hasCostDifference]="true"></app-kpi-widget>